module.exports = __webpack_public_path__ + "static/img/light1.2bfcd649.png";